import { useState } from "react";
import { Card, Col, Collapse, Container, Row } from "react-bootstrap";
import { renderMatchDetails, VerificationState } from "../common/verification";
import { LLMDashboardMarkdownRenderer } from "../common/LLMDashboardMarkdownRenderer";
import { ScanMulti } from "../common/models";

export const SectionMonitoringSummaryDetails = (props: {
    data: any,
    scanMulti?: ScanMulti,
}) => {

    const [verificationState, setVerificationState] = useState<VerificationState>();
    const [showEvidenceIndex, setShowEvidenceIndex] = useState<number | null>(null);

    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col className="description-text">
                        <Row>
                            <Col>
                                <strong>Evidence:</strong>
                            </Col>
                        </Row>
                        {
                            props.data.evidence.map((evi: any, index: number) => {
                                const verification = evi["verification"] as VerificationState | undefined;
                                return (
                                    <Container>
                                        <Row className="mt-2 description-section" onClick={() => {
                                            // setShowEvidenceIndex((showEvidenceIndex === null || showEvidenceIndex !== index) ? index : null); setVerificationState(verification)
                                        }}>
                                            <Col>
                                                <Row><Col><strong>{evi.source}</strong></Col></Row>
                                                <Row>
                                                    <Col>
                                                        <LLMDashboardMarkdownRenderer content={evi.detail} scanMulti={props.scanMulti} />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {verificationState && verificationState.matches.length > 0 && (
                                            <Collapse in={showEvidenceIndex === index}>
                                                <div>
                                                    <hr className="my-2" />
                                                    <Row>
                                                        <Col>
                                                            <small className="text-muted">
                                                                <strong>Context Data:</strong>
                                                            </small>
                                                            {renderMatchDetails(verificationState)}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Collapse>
                                        )}
                                    </Container>
                                );
                            })
                        }
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};
